/**
 * @generated SignedSource<<f4a3de0b555636961abb3663a61babf2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedMarketTrends_viewer$data = {
  readonly creatorMarketTrends: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "MarketTrendsEdge";
    } | null> | null;
    readonly priceStats: {
      readonly __typename: "MarketTrendsPriceStats";
    } | null;
    readonly topicDescription: {
      readonly categoryName: string | null;
      readonly hasArticle: boolean | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"SbSharedMarketTrendsPriceStats_creatorMarketTrends" | "SbSharedMarketTrendsTopSales_creatorMarketTrends">;
  } | null;
  readonly " $fragmentType": "SbSharedMarketTrends_viewer";
};
export type SbSharedMarketTrends_viewer$key = {
  readonly " $data"?: SbSharedMarketTrends_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedMarketTrends_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "uriRef"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedMarketTrends_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 5
        },
        {
          "kind": "Variable",
          "name": "uriRef",
          "variableName": "uriRef"
        }
      ],
      "concreteType": "MarketTrendsConnection",
      "kind": "LinkedField",
      "name": "creatorMarketTrends",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedMarketTrendsPriceStats_creatorMarketTrends"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedMarketTrendsTopSales_creatorMarketTrends"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MarketTrendsPriceStats",
          "kind": "LinkedField",
          "name": "priceStats",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MarketTrendsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MarketTrendsTopicDescription",
          "kind": "LinkedField",
          "name": "topicDescription",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "categoryName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasArticle",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "106f75d9c8acd7ff481b9288f23f3fbb";

export default node;
